a.s.userpickerelement = (function(){
	var my = {
		insert:function(s){
			var el = s.el || undefined;
			var filter = s.filter || {};
			var uid_list = s.uid_list || [];
			var cb_change = s.change || function(){};
			tpl.run({tpl:'/tpl/shared/userpickerelement/main.ejs?v='+v,data:{},cb:function(content){
				el.empty().append(content);
				setTimeout(function(){
					my.init(el,filter,uid_list,cb_change);
				},50);
			}});
		},
		init:function(el,filter,uid_list,cb_change){
			// Button
			$('button[data-action="userpickerelement_adduser"]').unbind('click').click(function(){
				a.s.userpicker.pick(function(userdatalist){
					userdatalist.forEach(function(userdata){
						my.userExist(el,userdata.uid,function(exist){
							if (!exist) {
								tpl.run({tpl:'/tpl/shared/userpickerelement/listuser.ejs?v='+v,data:userdata,cb:function(listuser){
									$('table tbody',el).append(listuser);
									my.initList(el);
								}});
							}
						});
					});
					cb_change();
				},{
					multiple: true,
					filter:filter
				});
			});
			// Clone filter to insertFilter so it doesn't affect user picker search filters
			var insertFilter = JSON.parse(JSON.stringify(filter));
			// Add users if uid_list consist of users
			if (uid_list.length>0) {
				insertFilter.uid = uid_list;
				my.insertUsers(insertFilter,el,cb_change);
			}
		},
		insertUsers:function(filter,el,cb_change){
			filter.accountname = localStorage.getItem('accountname');
			filter.token = localStorage.getItem('token');
			$.ajax({
				type:'GET',
				url:'/api/account/user/list/',
				data:filter,
				dataType:'json',
				cache: false,
				success:function(result) {
					if (result.success && result.list) {
						result.list.forEach(function(e){
							my.userExist(el,e.id,function(exist){
								if (!exist) {
									tpl.run({tpl:'/tpl/shared/userpickerelement/listuser.ejs?v='+v,data:e,cb:function(listuser){
										$('table tbody',el).append(listuser);
										my.initList(el);
									}});
								}
							});
						});
					}
				}
			}).done(function(){
				setTimeout(function(){
					cb_change();
				},200);
			});
		},
		initList:function(el){
			$('button[data-action="userpickerelement_removeuser"]',el).unbind('click').click(function(){
				$('tr[data-uid="'+$(this).attr('data-uid')+'"]').remove();
			});
		},
		userExist:function(el,uid,cb){
			if ($('table tr[data-uid="'+uid+'"]',el).length>0) {
				cb(true);
			}
			else {
				cb(false);
			}
		}
	}
	return my;
}());